import React, { useState, useEffect } from 'react';
import { TextArea } from '@livingdesign/react';
import { TEMPLATE } from '../../../../../../../consts/DBFields';
import { Controller } from 'react-hook-form';
import { useMessageDetailsForm } from '../../../../../../../contexts/MessageDetailsForm';
import { Snackbar } from '@material-ui/core';
import { SNACK_DURATION } from '../../../../../../../consts/Common';

export const QA_ID_PREFIX = "MsTeamsNotificationEdit";

function MSTeamsTemplateEditorContainer({
  loading,
  botContent,
  setBotContent,
}) {

  const [copied, toggleCopied] = useState(false);

  const {
    control,
    errors,
  } = useMessageDetailsForm();

  return (
    <div className='ms-teams-notification-edit-inputs' data-testid={`${QA_ID_PREFIX}-container`}>
      <div className='typo-1' data-testid={`${QA_ID_PREFIX}-required-field-label`}>*Required field</div>
      <Controller
        name="templateContent"
        control={control}
        rules={{ required: "Bot code is required"}}
        render={({field}) => (
          <TextArea
            name={"templateContent"}
            label={"Bot Code*"}
            id={`${QA_ID_PREFIX}-TextField`}
            data-testid={`${QA_ID_PREFIX}-textarea`}
            UNSAFE_style={{
              marginTop: "8px"
            }}
            value={botContent}
            onChange={(e) => {
              field.onChange(e.target.value);
              setBotContent(e.target.value)
            }}
            disabled={loading}
            error={errors.templateContent ? errors.templateContent.message : null} 
          />
        )}
      />
      <div className='typo-1' data-testid={`${QA_ID_PREFIX}-instruction-text`}>Once you've created your template in the notification builder, copy it and paste it here.</div>
      <button
        className='copy-to-clipboard-btn'
        data-testid={`${QA_ID_PREFIX}-copy-button`}
        style={{
          marginTop: "8px",
        }}
        onClick={() => {
          try {
            document.getElementById(`${QA_ID_PREFIX}-TextField`).select();
            document.execCommand("copy");
            toggleCopied(true);
          } catch (err) {
            toggleCopied(false);
          }
        }}
        disabled={!botContent}
      >
        Copy to clipboard
      </button>
      <Snackbar
          anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
          }}
          open={copied}
          autoHideDuration={SNACK_DURATION}
          onClose={() => toggleCopied(false)}
          id={`${QA_ID_PREFIX}-Snackbar`}
          data-testid={`${QA_ID_PREFIX}-snackbar`}
          message={<span data-testid={`${QA_ID_PREFIX}-snackbar-message`}>Bot code copied.</span>}
      >
      </Snackbar>
    </div>
  );
}

export default MSTeamsTemplateEditorContainer;
